const SESSION_EXPIRED_KEY = 'session-expired';

export function markSessionExpired(): void {
  sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
}

export function consumeSessionExpiredFlag(): boolean {
  const value = sessionStorage.getItem(SESSION_EXPIRED_KEY);
  if (value) {
    sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  }
  return value === '1';
}
